<template>
  <b-container class="highlight-container">
    
    <router-link to="/"><i class="fas fa-times btn--close"></i></router-link>

    <b-row>
      <b-col md="12" class="text-center px-0">
        <h1 v-scroll-reveal>42 Parks <br>Built Right Into Your <br>Neighbourhood</h1>
        <div class="image-wrapper" v-scroll-reveal="{delay: 150}">
          <b-img src="/img/parks-highlight-banner.png" fluid center alt="New Seaton Parks"/>
        </div>
      </b-col>
    </b-row>

    <b-row class="background--white">
      <b-col md="10" offset-md="1" class="text-center">
        <h3 class="text--red text--extrabold mb-25"><a data-fancybox="video" href="https://player.vimeo.com/video/359571569?title=0&byline=0&portrait=0&transparent=0">WATCH VIDEO</a></h3>
        <p v-scroll-reveal>
          New Seaton makes it easy for you to spend more time enjoying the outdoors all year long. That means <br class="d-none d-xl-block">warm
          summer afternoons having picnics or reading a book in the shade. Or relax in your favourite <br class="d-none d-xl-block">folding
          chair while you watch your child score their first goal in their summer soccer league. In the fall, <br class="d-none d-xl-block">you
          can take a short drive to the nearby Rouge National Urban Park to watch the leaves change. When <br class="d-none d-xl-block">winter
          comes around, you can toboggan, skate or cross- country ski, all right in your community.
        </p>
        <highlight-footer slot="register" />
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
  import highlightFooter from '@/components/HighlightFooter';
  export default {
    components: {
      highlightFooter
    },
    mounted() {
      this.$root.layout.methods.triggerViewPortAnimation()
    },
    transition: {
      mode: 'out-in',
      css: false,
      appear: true,

      enter(el, done) {
        done()
      },
      leave(el, done) {
        done()
      },
    },
  }
</script>

<style scoped>

</style>